import { map, reduce, trimStart, size, forEach, merge, sortBy } from 'lodash'

export const _map = map
export const _reduce = reduce
export const _trimStart = trimStart
export const _size = size
export const _forEach = forEach
export const _merge = merge
export const _sortBy = sortBy
